import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {VM} from '@hetao/scratch-core';
import promiseFinally from 'promise.prototype.finally';
promiseFinally.shim();

import {getConfig} from '../lib/service';
import {getParameterByName} from '../utils/tools.js';
import {saveHomework} from '../lib/homework-saver.js';
import {closeHomeworkUploadProgress, openHomeworkUploadProgress, closeFinishHomeworkLayer
    , openFinishHomeworkLayer, openLogin, setHomeworkProgressNum,
    setHomeworkQrcodeUrl, setSubmitingHomework} from '../reducers/modals';
import {getAccountInfo} from '../reducers/account-info';
import {setTargetState} from '../reducers/vm-status.js';

import {
    setSaveState,
    SAVE_STATE_NONE,
    SAVE_STATE_SAVING,
    SAVE_STATE_FAIL,
    SAVE_STATE_DONE
} from '../reducers/homework-save';

import {getHomeworkInfo} from '../lib/homework-info';
import storage from '../lib/storage';
import {projectTitleInitialState} from '../reducers/project-title';

import scratchTester from '../lib/scratch-tester/index.js';
import { estimateMemory, MEMORY_THRESHOLD } from '../components/menu-bar/project-performance.jsx';
import { isTeacherMode } from '../lib/hetao-mode.js';


/**
 * Project saver component passes a saveProject function to its child.
 * It expects this child to be a function with the signature
 *     function (saveProject, props) {}
 * The component can then be used to attach project saving functionality
 * to any other component:
 *
 * <ProjectSaver>{(saveProject, props) => (
 *     <MyCoolComponent
 *         onClick={saveProject}
 *         {...props}
 *     />
 * )}</ProjectSaver>
 */
class ProjectSaver extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            upLoadLine: 'qiniu'
        };
        getConfig().then(
            config => {
                this.setState({
                    upLoadLine: config.uploadType
                });
            }
        );

        bindAll(this, [
            'saveProject',
            'saveHomework',
            'submitHomework'
            // ,
            // 'createProject',
            // 'updateProject',
            // 'saveProject',
            // 'doStoreProject'
        ]);
    }
    componentDidMount () {
        this.homeworkInfo = getHomeworkInfo();
        this.courseId = Number(this.homeworkInfo.courseId);
        this.unitId = Number(this.homeworkInfo.unitId);
        this.lessonId = Number(this.homeworkInfo.lessonId);
    }
    saveHomework (e){
        if (this.props.isLoadingProjectError) {
            sa.track('s3_save_broken_homework');
            // eslint-disable-next-line no-alert
            alert('作业文件出现了点小问题，无法保存，请联系老师处理噢~');
            return;
        }
        e.stopPropagation(); // 不再冒泡，智齿会因为点击了它的区域之外然后收回
        if (!this.props.accountInfo.isLogin) {
            this.props.openLogin();
            return;
        }
        this.props.updateSaveState(SAVE_STATE_SAVING);

        this.props.vm.saveProjectSb3()
            .then(content => saveHomework(content, 'DRAFT', this.state.upLoadLine, null)
                .then(data => {
                    ht.track('s3_save', {
                        context: {
                            courseId: this.courseId,
                            unitId: this.unitId,
                            lessonId: this.lessonId,
                            currentUrl: location.href,
                            stageDisplayMode: localStorage.getItem('stageDisplayMode')
                        }
                    });
                    this.props.updateSaveState(SAVE_STATE_DONE);
                    // 环信提问时提交草稿
                    const iframe = document.getElementsByTagName('iframe');
                    // eslint-disable-next-line
                    iframe.length !== 0 && iframe[0].className && !new RegExp('ZCChatFrame').test(iframe[0].className) &&
                    this.saveDraftTohx(data.url, this.unitId, this.lessonId, this.courseId);
                })
            )
            .catch(() => {
                this.setState({upLoadLine: 'upyun'});
                this.saveOther();
            })
            .finally(() => {
                setTimeout(() => this.props.updateSaveState(SAVE_STATE_NONE), 2000);
            });
    }
    submitHomework (){
        if (this.props.isLoadingProjectError) {
            sa.track('s3_submit_broken_homework');
            // eslint-disable-next-line no-alert
            alert('作业文件出现了点小问题，无法提交，请联系老师处理噢~');
            return;
        }
        ht.track('s3_submit', {
            context: {
                courseId: this.courseId,
                unitId: this.unitId,
                lessonId: this.lessonId,
                currentUrl: location.href,
                stageDisplayMode: localStorage.getItem('stageDisplayMode')
            }
        });
        sa.track('s3_submit');
        if (!this.props.accountInfo.isLogin) {
            this.props.openLogin();
            return;
        }
        this.props.onSetSubmitingHomework(true);
        this.props.openHomeworkUploadProgress();
        this.props.vm.saveProjectSb3().then(content => saveHomework(content, 'PUBLISHED', this.state.upLoadLine, progressNum => { //eslint-disable-line
            this.props.setHomeworkProgressNum(progressNum);
        }).then(res => {
            // 上传成功
            this.props.onSetSubmitingHomework(false);
            this.props.closeHomeworkUploadProgress();
            this.props.setHomeworkProgressNum(0);
            this.props.openFinishHomeworkLayer();
            this.props.setHomeworkQrcodeUrl(res.qrcodeUrl);
            // 重置initVMTargets
            const initVMTargets = {};
            this.props.vm.runtime.targets.forEach(target => {
                initVMTargets[target.id] = Object.keys(target.blocks._blocks);

            });
            this.props.onInitializeVMTargets(initVMTargets);


        }))
            .catch(() => {
                this.setState({upLoadLine: 'upyun'});
                this.submitOther();
            });
    }
    saveDraftTohx (url, unitId, lessonId, courseId) {
        // eslint-disable-next-line
        easemobim.sendExt({
            ext: {
                imageName: 'mallImage.png',
                type: 'custom',
                msgtype: {
                    track: {
                        title: '我正在做的作业：',
                        desc: `【${getParameterByName('title')}】点我进入哦`,
                        img_url: '//img.hetao101.com/icon/logo_rectangle108x108.png',
                        item_url: `//${window.location.host}?url=${url}&unitId=${unitId}&lessonId=${lessonId}&title=${getParameterByName('title')}&courseId=${courseId}` // eslint-disable-line
                    }
                }
            }
        });
    }
    saveOther () {
        this.props.vm.saveProjectSb3()
            .then(content => saveHomework(content, 'DRAFT', this.state.upLoadLine, null)
                .then(data => {
                    ht.track('s3_save', {
                        context: {
                            courseId: this.courseId,
                            unitId: this.unitId,
                            lessonId: this.lessonId,
                            currentUrl: location.href,
                            stageDisplayMode: localStorage.getItem('stageDisplayMode')
                        }
                    });
                    this.props.updateSaveState(SAVE_STATE_DONE);
                    // 环信提问时提交草稿
                    const iframe = document.getElementsByTagName('iframe');
                    // eslint-disable-next-line
                    iframe.length !== 0 && iframe[0].className && !new RegExp('ZCChatFrame').test(iframe[0].className) &&
                    this.saveDraftTohx(data.url, this.unitId, this.lessonId, this.courseId);
                })
            )
            .catch(() => {
                this.props.updateSaveState(SAVE_STATE_FAIL);
            })
            .finally(() => {
                setTimeout(() => this.props.updateSaveState(SAVE_STATE_NONE), 2000);
            });
    }
    submitOther () {
        this.props.vm.saveProjectSb3().then(content => saveHomework(content, 'PUBLISHED', this.state.upLoadLine).then(res => { // eslint-disable-line
            // 上传成功
            this.props.onSetSubmitingHomework(false);
            this.props.closeHomeworkUploadProgress();
            this.props.openFinishHomeworkLayer();
            this.props.setHomeworkQrcodeUrl(res.qrcodeUrl);
        }))
            .catch(() => {
                /* eslint-disable no-alert*/
                window.confirm('作业提交失败了...');
                this.props.onSetSubmitingHomework(false);
                this.props.closeHomeworkUploadProgress();
                ht.track('s3_submit_homework_fail', {
                    context: {
                        courseId: this.courseId,
                        unitId: this.unitId,
                        lessonId: this.lessonId,
                        currentUrl: location.href,
                        stageDisplayMode: localStorage.getItem('stageDisplayMode')
                    }
                });

            });
    }
    saveProject () {
        if (isTeacherMode() && estimateMemory(this.props.vm) > MEMORY_THRESHOLD.HIGH) {
            if (!confirm('作品内存占用过高，可能在学生端无法打开，是否继续保存？(减少角色造型数量和缩小图片尺寸可降低内存)')) {
                return;
            }
        }

        const saveLink = document.createElement('a');
        document.body.appendChild(saveLink);

        scratchTester.getTesterFile().then(testerFile => {
            this.props.vm.saveProjectSb3(false, [testerFile]).then(content => {
                // Use special ms version if available to get it working on Edge.
                if (navigator.msSaveOrOpenBlob) {
                    navigator.msSaveOrOpenBlob(content, this.props.projectFilename);
                    return;
                }
                ht.track('s3_save_tolocal', {
                    context: {
                        courseId: this.courseId,
                        unitId: this.unitId,
                        lessonId: this.lessonId,
                        currentUrl: location.href,
                        stageDisplayMode: localStorage.getItem('stageDisplayMode')
                    }
                });
                const url = window.URL.createObjectURL(content);
                saveLink.href = url;
                saveLink.download = this.props.projectFilename;
                saveLink.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(saveLink);
            });
        });
    }

    doStoreProject (id) {
        return this.props.saveProjectSb3()
            .then(content => {
                const assetType = storage.AssetType.Project;
                const dataFormat = storage.DataFormat.SB3;
                const body = new FormData();
                body.append('sb3_file', content, 'sb3_file');
                return storage.store(
                    assetType,
                    dataFormat,
                    body,
                    id
                );
            });
    }
    createProject () {
        return this.doStoreProject();
    }
    updateProject () {
        return this.doStoreProject(this.props.projectId);
    }


    render () {
        const {
            /* eslint-disable no-unused-vars */
            children,
            vm,
            /* eslint-enable no-unused-vars */
            ...props
        } = this.props;

        // const {
        //     children
        // } = this.props;
        // return children(
        //     this.saveProject,
        //     this.updateProject,
        //     this.createProject
        // );


        if (this.props.mode === 'submitHomework') {
            return this.props.children(this.submitHomework);
        } else if (this.props.mode === 'saveHomework') {
            return this.props.children(this.saveHomework);
        }
        return this.props.children(this.saveProject, props);
    }
}

ProjectSaver.propTypes = {
    accountInfo: PropTypes.shape({
        isLogin: PropTypes.bool
    }),
    children: PropTypes.func,
    closeFinishHomeworkLayer: PropTypes.func,
    closeHomeworkUploadProgress: PropTypes.func,
    isLoadingProjectError: PropTypes.bool,
    mode: PropTypes.string,
    onInitializeVMTargets: PropTypes.func,
    onSetSubmitingHomework: PropTypes.func,
    openFinishHomeworkLayer: PropTypes.func,
    openHomeworkUploadProgress: PropTypes.func,
    openLogin: PropTypes.func,
    projectFilename: PropTypes.string,
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    saveProjectSb3: PropTypes.func,
    setHomeworkProgressNum: PropTypes.func,
    setHomeworkQrcodeUrl: PropTypes.func,
    updateSaveState: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired

};
const getProjectFilename = (curTitle, defaultTitle) => {
    let filenameTitle = curTitle;
    if (!filenameTitle || filenameTitle.length === 0) {
        filenameTitle = defaultTitle;
    }
    return `${filenameTitle.substring(0, 100)}.sb3`;
};
const mapStateToProps = state => ({
    accountInfo: getAccountInfo(state),
    isLoadingProjectError: state.scratchGui.vm.runtime.targets.filter(target => target.isStage).length === 0,
    vm: state.scratchGui.vm,
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
    projectFilename: getProjectFilename(state.scratchGui.projectTitle, projectTitleInitialState),
    projectId: state.scratchGui.projectId
});

const mapDispatchToProps = dispatch => ({
    openLogin: () => dispatch(openLogin()),
    closeHomeworkUploadProgress: () => dispatch(closeHomeworkUploadProgress()),
    openHomeworkUploadProgress: () => dispatch(openHomeworkUploadProgress()),
    closeFinishHomeworkLayer: () => dispatch(closeFinishHomeworkLayer()),
    openFinishHomeworkLayer: () => dispatch(openFinishHomeworkLayer()),
    setHomeworkProgressNum: num => dispatch(setHomeworkProgressNum(num)),
    setHomeworkQrcodeUrl: qrcodeUrl => dispatch(setHomeworkQrcodeUrl(qrcodeUrl)),
    onInitializeVMTargets: initVMTargetsHash => dispatch(setTargetState(initVMTargetsHash)),
    onSetSubmitingHomework: bool => dispatch(setSubmitingHomework(bool)),
    updateSaveState: state => dispatch(setSaveState(state))
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectSaver);
